import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { createI18nWrapper } from './i18next';

export const useI18n = () => {
  const { i18n } = useTranslation('translation');

  // Key the wrapper on the ACTIVE language, not only the (identity-stable) i18n instance: a live
  // language switch then mints a new `t`, so useMemo/React.memo consumers keyed on [t] recompute
  // their baked strings instead of serving the old locale until remount.
  const language = i18n.resolvedLanguage ?? i18n.language;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => createI18nWrapper(() => i18n), [i18n, language]);
};

export { I18nextProvider, Trans } from 'react-i18next';
